
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.977 4.006H10.023C5.592 4.006 2 7.327 2 11.424v9.162c0 4.098 3.592 7.42 8.023 7.42h11.954c4.431 0 8.023-3.322 8.023-7.42v-9.161c0-4.098-3.592-7.42-8.023-7.42z","fill":"#0C5385"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.156 4.006h13.869c.016.308.027.623.027.937 0 9.846-8.443 18.065-19.68 19.995A7.551 7.551 0 012 20.581v-9.162C2 7.337 5.219 4 9.156 4v.006z","fill":"#1269A3"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.058 10.194l9.757 5.185a2.442 2.442 0 002.368 0l9.757-5.185c.798-.425 1.298-1.17 1.394-2.096a2.679 2.679 0 00-.915-2.366c-1.245-1.076-2.841-1.727-4.575-1.727H9.154A6.96 6.96 0 004.58 5.732c-.686.596-1.016 1.44-.915 2.366.101.927.596 1.671 1.394 2.096z","fill":"#104A70"}})])
          )
        }
      }
    